import React from 'react';

import { cssMap } from '@atlaskit/css';
import DragHandleVerticalIcon from '@atlaskit/icon/core/drag-handle-vertical';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	dragHandle: {
		position: 'absolute',
		top: token('space.100'),
		left: token('space.0'),
		width: '16px',
		height: '16px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: token('radius.small'),
		transition: 'opacity 120ms ease-in-out',
		cursor: 'grab',
		zIndex: 1,
	},
});

/**
 * A visual handle that shows the drag affordance for the app tile.
 */
export const DragHandle = ({ testId }: { testId: string }): React.JSX.Element => {
	return (
		<Box testId={testId} xcss={styles.dragHandle}>
			<DragHandleVerticalIcon label="Reorder" size="small" />
		</Box>
	);
};
